import React from "react";
import { Route, Routes } from "react-router-dom";
import ToegangscontroleIndex from "./index";

const ToegangscontroleRouter = () => {
  return (
    <Routes>
      <Route exact path="/" element={<ToegangscontroleIndex />} />
    </Routes>
  );
};

export default ToegangscontroleRouter;